import type { ReportPdfRequest, ReportPdfResponse } from '@src/models/interfaces/reportPdf.interface';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

export class ReportPdfRepository {
  async generate(request: ReportPdfRequest): Promise<ReportPdfResponse> {
    const response = await apiCallable<ReportPdfRequest, ReportPdfResponse>(
      API_OPERATIONS.GENERATE_REPORT_PDF,
      { timeout: 300_000 },
    )(request);
    return response.data;
  }
}
